module.exports = __webpack_public_path__ + "img/qrcode.jpg";